import * as appointmentTypes from 'modules/appointments/actionTypes';
import * as actionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const set = (_, { payload }) => payload;

const reset = (state, { payload }) => (payload?.action === 'REPLACE' ? state : initialState);

const setFromAppointment = (state, { payload }) => payload?.intervention?.id ?? state;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: reset,
  [actionTypes.SELECT_INTERVENTION]: set,
  [appointmentTypes.PUT_SUCCESS]: setFromAppointment,
  [appointmentTypes.POST_SUCCESS]: setFromAppointment,
  [appointmentTypes.FETCH_INTERVENTION_SUCCESS]: setFromAppointment,
  [appointmentTypes.FETCH_APPOINTMENT_SUCCESS]: setFromAppointment,
});
